export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type d'adresse"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type de compte"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devise"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer une adresse"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer un compte"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Création d'une nouvelle adresse"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer un nouveau compte"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le nom"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionnez la devise"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionnez le type"])}
}